import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "..";

const selectStoreConfig = (state: RootState) => state.storeConfig.storeConfig;
const selectPaymentFrequencyConfig = (state: RootState) => state.storeConfig.paymentFrequencyConfig;

export const selectStoreConfigSelector = createSelector(
  selectStoreConfig,
  (storeConfig) => storeConfig
);

export const selectPaymentFrequencyConfigSelector = createSelector(
  selectPaymentFrequencyConfig,
  (paymentFrequencyConfig) => paymentFrequencyConfig
);
